<template>
    <div class="history">
        <div v-if="items" class="align-center text-right">
            <div class="d-flex justify-end">
                <slot name="buttons" :rows="rows" :titles="titles" :set-rows="setRows"></slot>
                <v-btn :disabled="!mappingsSelected || !dataChanged"
                       class="mb-2"
                       color="primary"
                       elevation="0"
                       @click="apply"
                >Сохранить</v-btn>
            </div>
            <div class="d-flex justify-end align-center mb-4">
                <v-spacer></v-spacer>
                <v-text-field
                    type="number"
                    v-model="changeTime"
                    label="Время"
                    hint="Добавить или удалить время"
                    persistent-hint
                ></v-text-field>
                <v-btn icon color="primary">
                    <v-icon @click="deleteTime">mdi-delete</v-icon>
                </v-btn>
            </div>
        </div>

        <div class="history-table">
            <div class="history-table__container">
                <vue-excel-editor v-if="rows"
                                  v-model="rows"
                                  no-paging
                                  enter-to-south
                                  :no-header-edit="false"
                                  no-footer
                                  :record-label="(recordPosition, record) => (recordPosition-1)+'/'+record.t"
                >
                    <vue-excel-column v-for="key in titles" :key="key"
                                      :field="key"
                                      :label="key"
                                      type="number"
                                      :invisible="key === 't'"
                    ></vue-excel-column>
                </vue-excel-editor>
            </div>
        </div>

    </div>
</template>

<script>
import {cloneDeep} from "lodash";

export default {
    props: ['value', 'wells', 'someWells'],
    data() {
        return {
            item: null,
            changeTime: null,
            rows: [],
            titles: [],
            history: {},
            separator: ';',
            file: null,
            dataMap: {},
            saved: null,
            dataChanged: false
        }
    },
    watch: {
        value() {
            this.initItem();
            this.dataChanged = false;
        },
        items() {
            this.guessDataMap();
            this.dataChanged = true;
        },
        dataMap: {
            deep: true,
            handler() {
                this.dataChanged = true;
            }
        }
    },
    async created() {
        this.initItem();
    },
    methods: {
        initItem() {
            if (this.value) {
                this.item = cloneDeep(this.value);
                this.titles = Object.keys(this.item)
                this.updateRows();
            }
            else {
                this.item = null;
                this.rows = [];
                this.titles = [];
            }
        },
        updateRows() {
            if (!this.item) {
                return false;
            }

            let firstCol = Object.keys(this.item)[0];
            if (!this.item[firstCol]) {
                return false;
            }

            let itemsCount = this.item[firstCol].length;
            let items = [];
            for (let i = 0; i < itemsCount; i++) {
                let row = {};
                for (let col of this.titles) {
                    row[col] = this.value[col][i];
                }

                items.push(row);
            }

            this.rows = items;
        },
        deleteTime() {
            let time = parseInt(this.changeTime);
            if (!time) {
                return;
            }

            this.rows = this.rows.filter(row => row.t !== time);
            this.dataChanged = true;
        },
        setRows(newRows) {
            this.rows = newRows;
            let wellNames = this.wells.map(well => well?.name);
            this.titles = Object.keys(newRows[0]).filter(title => title.toLowerCase() === 't' || wellNames.includes(title));
            this.guessDataMap();
            this.dataChanged = true;
        },
        getColumn(code) {
            return this.items.map(item => item[code]);
        },
        apply() {
            let wellsData = {};
            let mappings = Object.keys(this.dataMap).reduce((result, key) => {
                let value = this.dataMap[key];
                result[value] = key;
                return result;
            }, {});

            wellsData['t'] = this.getColumn(mappings['t']);
            for (let well of this.wells) {
                if (mappings['well_' + well.id]) {
                    wellsData[well.id] = this.getColumn(mappings['well_' + well.id]);
                }
            }

            this.item = wellsData;
            this.saved = cloneDeep(wellsData);
            this.dataChanged = false;

            this.$emit('input', this.saved);
        },
        guessDataMap() {
            if (!this.value) {
                return;
            }

            let uploadedColumnTitles = this.titles;
            let uploadedColumnTitlesLc = uploadedColumnTitles.map(title => title.toLowerCase().trim());
            let guessedDataMap = {};
            let timeIndex = uploadedColumnTitlesLc.indexOf('t');
            if (timeIndex !== -1) {
                let timeColumnTitle = uploadedColumnTitles[timeIndex];
                guessedDataMap[timeColumnTitle] = 't';
            }

            for (let well of this.wells) {
                let columnIndex = uploadedColumnTitlesLc.indexOf(well.id.toLowerCase().trim());
                if (columnIndex !== -1) {
                    let columnTitle = uploadedColumnTitles[columnIndex];
                    guessedDataMap[columnTitle] = 'well_'+well.id;
                }
            }

            this.dataMap = guessedDataMap;
        }
    },
    computed: {
        items() {
            return this.rows || [];
        },
        headers() {
            if (!this.titles) {
                return false;
            }

            return this.titles.map(title => {
                return {
                    text: title,
                    value: title,
                    slot: 'header.' + title,
                    sort: false,
                }
            });
        },
        wellsAndTime() {
            let defaultCols = [
                {text: 'Не задано', value: ''},
                {text: 'Время', value: 't'}
            ];

            if (!this.wells) {
                return defaultCols;
            }

            return defaultCols.concat(
                this.wells.map(well => {
                    return {
                        text: well.id,
                        value: 'well_' + well.id,
                    }
                })
            )
        },
        mappingsSelected() {
            if (!this.wells) {
                return false;
            }

            let dataValues = Object.values(this.dataMap);
            let wellMappingsSelected;
            if (this.someWells) {
                wellMappingsSelected = this.wells.some(well => {
                    return dataValues.indexOf('well_' + well.id) !== -1;
                }, true);
            }
            else {
                wellMappingsSelected = this.wells.every(well => {
                    return dataValues.indexOf('well_' + well.id) !== -1;
                }, true);
            }
            let timeSelected = dataValues.indexOf('t') !== -1;
            return wellMappingsSelected && timeSelected;
        },
        appliedHeaders() {
            if (!this.saved) {
                return false;
            }

            return Object.keys(this.saved).map(id => {
                return id === 't'
                    ? {text: 'Время, дни', value: 't'}
                    : {text: id, value: id}
            });
        },
        appliedItems() {
            let items = [];
            for (let index in this.saved['t']) {
                let item = Object.keys(this.saved).reduce((result, id) => {
                    result[id] = this.saved[id][index];
                    return result;
                }, {});

                items.push(item);
            }

            return items;
        }
    }
}
</script>

<style scoped lang="scss">
</style>
